export { default as authentication } from './authentication.json';
export { default as balances } from './balances.json';
export { default as beneficiaries } from './beneficiaries.json';
export { default as channelPayments } from './channelPayments.json';
export { default as common } from './common.json';
export { default as dashboard } from './dashboard.json';
export { default as dataTable } from './dataTable.json';
export { default as deposits } from './deposits.json';
export { default as errorFallback } from './errorFallback.json';
export { default as fraudWarningAcknowledgement } from './fraudWarningAcknowledgement.json';
export { default as invoicing } from './invoicing.json';
export { default as loggedOutPage } from './loggedOutPage.json';
export { default as mfa } from './mfa.json';
export { default as notFoundPage } from './notFoundPage.json';
export { default as payments } from './payments.json';
export { default as regex } from './regex.json';
export { default as transactions } from './transactions.json';
export { default as transfers } from './transfers.json';
export { default as userManagement } from './userManagement.json';
